import { render, staticRenderFns } from "./KnowledgeCatgeoryTile.vue?vue&type=template&id=f55326f6&"
import script from "./KnowledgeCatgeoryTile.vue?vue&type=script&lang=js&"
export * from "./KnowledgeCatgeoryTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports